/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Currency_EurInputs */

const cs_currency_eur = /** @type {(inputs: Currency_EurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR — euro`)
};

const en_currency_eur = /** @type {(inputs: Currency_EurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR — euro`)
};

/**
* | output |
* | --- |
* | "EUR — euro" |
*
* @param {Currency_EurInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const currency_eur = /** @type {((inputs?: Currency_EurInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Currency_EurInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_currency_eur(inputs)
	return cs_currency_eur(inputs)
});